import { createAsyncThunk } from '@reduxjs/toolkit';
import {
    AppInstallationRequest,
    GetUsersRequest,
    GetGithubAppUrl,
    CreateProjectRequest
} from 'src/types/onboarding';
import { UpdateProjectRequest } from 'src/types/projects';

import * as api from 'src/api/onboarding';

export const SLICE_NAME = 'projectOnboarding';

export const ACTION_TYPES = {
    CREATE_PROJECT: `${SLICE_NAME}/createProject`,
    GET_GITHUB_APP_URL: `${SLICE_NAME}/getGithubAppUrl`,
    APP_INSTALLATION_CALLBACK: `${SLICE_NAME}/appInstallationCallback`,
    GET_USERS: `${SLICE_NAME}/getUsers`,
    UPDATE_PROJECT: `${SLICE_NAME}/updateProject`,
    GET_SKILLS: `${SLICE_NAME}/getSkills`
};

export const appInstallationCallback = createAsyncThunk(
    ACTION_TYPES.APP_INSTALLATION_CALLBACK,
    async (params: AppInstallationRequest, { rejectWithValue }) => {
        try {
            const response = await api.appInstallationCallback(params);
            return response;
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);

export const createProject = createAsyncThunk(
    ACTION_TYPES.CREATE_PROJECT,
    async (params: CreateProjectRequest, { rejectWithValue }) => {
        try {
            const response = api.createProject(params);
            return response;
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);

export const getGithubAppUrl = createAsyncThunk(
    ACTION_TYPES.GET_GITHUB_APP_URL,
    async (params: GetGithubAppUrl, { rejectWithValue }) => {
        try {
            const response = api.getGithubAppUrl(params);
            return response;
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);

export const getUsers = createAsyncThunk(
    ACTION_TYPES.GET_USERS,
    async (params: GetUsersRequest, { rejectWithValue }) => {
        try {
            const response = await api.getUsers(params);
            return response;
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);

export const updateProject = createAsyncThunk(
    ACTION_TYPES.UPDATE_PROJECT,
    async (params: UpdateProjectRequest, { rejectWithValue }) => {
        try {
            const response = await api.updateProject(params);
            return response;
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);

export const getSkills = createAsyncThunk(
    ACTION_TYPES.GET_SKILLS,
    async (_params, { rejectWithValue }) => {
        try {
            const response = await api.getSkills();
            return response.data;
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);
